import { AxiosError } from "axios";
import { FieldValues, UseFormSetError } from "react-hook-form";
import { useMutation, useQueryClient } from "react-query";
import { api } from "services/api";
import { User } from "types/User";
import { handleFormErrors } from "utils/Form";
import { axiosError, axiosSuccess, handleRequestSuccess } from "utils/Request";

async function editUser(user: User, newData: User) {
  const { data } = await api.put(`/users/${user.id}`, { ...newData }).then(axiosSuccess).catch(axiosError);
  return data;
}

export function useEditUser(errorSetter: UseFormSetError<FieldValues>) {
  const queryClient = useQueryClient();

  return useMutation(({ userToEdit, data }: any) => editUser(userToEdit, data), {
    onSuccess: (data: User) => {
      handleRequestSuccess(`Usuário "${data.name}" editado com sucesso!`);
      queryClient.invalidateQueries('users');
      queryClient.invalidateQueries('count');
    },
    onError: (error: AxiosError) => {
      handleFormErrors(error, errorSetter);
    }
  });
}
